import type { FC } from "react";

import {
  DIALOG_FOOTER_CTAS_DEFAULTS,
  type TDialogFooterProps,
} from "@/ui/components/overlay/Dialog/Dialog.config";
import { cn } from "@/ui/lib/utils";
import { DialogFooterCtas } from "./DialogFooterCtas";

export const DialogFooter: FC<TDialogFooterProps> = (
  {
    className,
    ctas,
    align = DIALOG_FOOTER_CTAS_DEFAULTS.align,
    ...props
  },
) => (
  <div
    data-component="DialogFooter"
    className={cn(
      className,
    )}
    {...props}
  >
    <DialogFooterCtas align={align} ctas={ctas} />
  </div>
);

DialogFooter.displayName = "DialogFooter";
